import { useMutation } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

// Token response type
export interface LiveKitTokenResponse {
  token: string
  serverUrl: string
  roomName: string
  campaignId: number
  agentId?: string
  agentName: string
  participantIdentity: string
}

// Room delete response type
export interface LiveKitRoomDeleteResponse {
  roomName: string
  warning?: string
}

/**
 * Hook to generate LiveKit token for browser calls
 */
export function useLiveKitToken() {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async ({ campaignId, agentId }: { campaignId: number; agentId?: string }) => {
      return apiClient<LiveKitTokenResponse>('/livekit/token', {
        method: 'POST',
        body: JSON.stringify({ campaignId, agentId }),
      })
    },
  })
}

/**
 * Hook to delete LiveKit room
 */
export function useLiveKitRoomDelete() {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (roomName: string) => {
      return apiClient<LiveKitRoomDeleteResponse>('/livekit/room', {
        method: 'DELETE',
        body: JSON.stringify({ roomName }),
      })
    },
  })
}